// Orpheus top menu effects 
$(document).ready(function () {
	$(window).on("scroll", function() {
      if($(window).scrollTop() > 901) {
          $("#orpheus").addClass("header-transparent");
          $(".dropdown-content").removeClass("content-transparent");
      } else {
          $("#orpheus").removeClass("header-transparent");
       	  $(".dropdown-content").addClass("content-transparent");
      }
	});	
});

$('.menu').click (function(){
  event.preventDefault();
  $(this).toggleClass('open');
  $(this).add('.header_mobile').toggleClass('is-active');
  $('.orpheus-main-menu-mobile').toggleClass('nav-show');
  $('html, body').toggleClass('is-noscroll');
});
// End of Orpheus top menu effects 

// Toggle Collapse FAQ
$('.faq li .question').click(function () {
  $(this).find('.plus-minus-toggle').toggleClass('collapsed');
  $(this).parent().toggleClass('active');
});

// Toggle Collapse Mobile menu items
$('.menu-faq li .menu-question').click(function () {
  $(this).find('.menu-plus-minus-toggle').toggleClass('collapsed');
  $(this).parent().toggleClass('active');
});